<template>
        <section id="about" class="about section">

<div class="container" data-aos="fade-up" data-aos-delay="100">
  <div class="row align-items-xl-center gy-5">

    <div class="col-xl-5 content">
      <h3>A propos de nous</h3>
      <h2>ANaGeM</h2>
      <p>En vue de doter les villes du Bénin d’infrastructures et d’équipements marchands modernes, le Programme d’Action du Gouvernement a mis en œuvre la construction de plusieurs marchés urbains et régionaux dans le but d’accroître les capacités d’accueil des équipements marchands, de décongestionner les zones commerciales et d’améliorer leur attractivité.</p>
      <br>
      <a href="https://www.gouv.bj/opportunite/82/avis-recrutement-multipostes-compte-agence-nationale-gestion-marches-anagem-/" class="read-more"><span>Lire plus</span><i class="bi bi-arrow-right"></i></a>
    </div>

    <div class="col-xl-7">
      <div class="row gy-4 icon-boxes">

        <div class="col-md-6" data-aos="fade-up" data-aos-delay="200">
          <div class="icon-box">
            <i class="bi bi-buildings"></i>
            <h3>Marchés</h3>
            <p>Nous supervisons les marchés et assurons une bonne interaction entre les acteurs</p>
          </div>
        </div> <!-- End Icon Box -->

        <div class="col-md-6" data-aos="fade-up" data-aos-delay="300">
          <div class="icon-box">
            <i class="bi bi-file-earmark-text"></i>
            <h3>Besoins</h3>
            <p>Nous anticipons les besoins des marchands afin d’améliorer l’organisation des marchés.</p>
          </div>
        </div> <!-- End Icon Box -->

        <div class="col-md-6" data-aos="fade-up" data-aos-delay="400">
          <div class="icon-box">
            <i class="bi bi-buildings"></i>
            <h3>Infrastructure</h3>
            <p>Nous assurons la pérennité et la modernité des infrastructures.</p>
          </div>
        </div> <!-- End Icon Box -->

        <div class="col-md-6" data-aos="fade-up" data-aos-delay="500">
          <div class="icon-box">
            <i class="bi bi-graph-up-arrow"></i>
            <h3>Promotion</h3>
            <p>Ces nouveaux marchés feront la promotion de vos activités</p>
          </div>
        </div> <!-- End Icon Box -->

      </div>
    </div>

  </div>
</div>

</section>
</template>
<script lang="ts">
	import { defineComponent,onMounted } from "vue";

	export default defineComponent({
		name: "SectionOne",
		components: {},
		setup() {
			//
		}		
	});
</script>